var chunkMapping = {
	"201": [
		1201
	],
	"332": [
		6332
	],
	"792": [
		9922,
		3809,
		870,
		7028,
		5777
	],
	"943": [
		324
	]
};
var idToExternalAndNameMapping = {
	"324": [
		"default",
		"./SpotlightService",
		2036
	],
	"870": [
		"default",
		"./Dialog",
		2036
	],
	"1201": [
		"default",
		"./AnnouncementBanner",
		2036
	],
	"3809": [
		"default",
		"./Firebase",
		2036
	],
	"5777": [
		"default",
		"./CompanyPicker",
		2036
	],
	"6332": [
		"default",
		"./SpotlightCard",
		2036
	],
	"7028": [
		"default",
		"./APIKeyService",
		2036
	],
	"9922": [
		"default",
		"./Api",
		2036
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}